export enum SocketNamespace {
  Reports = 'reports',
  Chat = 'chat',
  Queries = 'chat/queries',
  Speech = 'speech',
  Projects = 'projects',
  Transcripts = 'transcripts',
  Files = 'files',
}

export enum QuerySocketEvent {
  QueryTakingTooLong = 'query/taking-too-long',
  QueryAvailable = 'query/available',
  QueryResponseStreaming = 'query/response-streaming',
  QueryErrored = 'query/errored',
  QueryFollowupsAvailable = 'query/followups-available',
  QueryAudioAvailable = 'query-audio-available',
  QueryChainOfThought = 'query/chain-of-thought',
  SegmentationResult = 'segmentation/result',
  SegmentationCompleted = 'segmentation/completed',
}

export enum ChatSocketEvent {
  ChatDeleted = 'chat-deleted',
}

export enum LifeCycleSocketEvent {
  Connect = 'connect',
  ConnectError = 'connect_error',
  Disconnect = 'disconnect',
}

export enum FileSocketEvent {
  ChatAvailable = 'file-chat-available',
  PreviewAvailable = 'preview-available',
  TranscriptAvailable = 'transcript-available',
  UploadAvailable = 'file-upload-available',
  TagsAvailable = 'file-tags-available',
}

export enum ReportSocketEvent {
  ReportAvailable = 'report-available',
  ReportError = 'report-error',
}

export enum ProjectSocketEvent {
  TranscriptCleanupCompleted = 'transcript-cleanup-completed',
  TranscriptCleanupFailed = 'transcript-cleanup-failed',
}

export enum TranscriptSocketEvent {
  RedactionComplete = 'redaction-complete',
  RedactionError = 'redaction-error',
  TagSummariesAvailable = 'tag-summaries-available',
}

export enum ProjectSocketEvent {
  TagSummariesAvailable = 'tag-summaries-available',
  TranscriptCleanupEvent = 'transcript-cleanup-event',
}

export type SocketEvent =
  | LifeCycleSocketEvent
  | ReportSocketEvent
  | ChatSocketEvent
  | ProjectSocketEvent
  | TranscriptSocketEvent
  | ProjectSocketEvent
  | FileSocketEvent
  | QuerySocketEvent;